export const dismissNotification = async (historyId: number, onError?: () => void) => {
  try {
    await fetch(`/api/v4/ai_generation_histories/${historyId}/dismiss`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    onError ? onError() : console.error(error);
  }
};
